export enum ButtonLayout {
    Wide = 'wide',
    Compact = 'compact',
}
